import {Base,Axios} from "@/api/Base"

export class ReportExport extends Base {
    path = "report/export"
    download(param = {}) {
        return Axios.get(this.path,{ params: param, responseType: "blob" })
    }
}